import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Sparkle, ChartLineUp, FunnelSimple, Export } from "@phosphor-icons/react";

// Bump this id whenever the entries below change: the popup re-appears once per user.
const CHANGELOG_VERSION = "2026-06-1";
const STORAGE_KEY = "pc_whatsnew_seen";

const ENTRIES = [
  {
    icon: FunnelSimple,
    title: "Trend Team per competizione",
    body: "In Analisi squadra ora scegli la competizione (Serie A o Women's Cup) da un menu a tendina: l'asse mostra le giornate relative G1, G2, G3… proprio come nel Trend giocatrici.",
  },
  {
    icon: ChartLineUp,
    title: "Statistiche SICS nei trend",
    body: "Le metriche tecniche SICS (tiri, passaggi, reti…) compaiono sia nel Trend giocatrici sia nel Trend squadra, incluse le partite di coppa.",
  },
  {
    icon: Export,
    title: "Export PNG e PDF",
    body: "Esporta qualsiasi grafico di trend in PNG o PDF con un clic, pronto per report e presentazioni.",
  },
];

export default function WhatsNewDialog() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(STORAGE_KEY) !== CHANGELOG_VERSION) setOpen(true);
    } catch { /* ignore */ }
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(STORAGE_KEY, CHANGELOG_VERSION); } catch { /* ignore */ }
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) dismiss(); }}>
      <DialogContent className="max-w-lg" data-testid="whatsnew-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-primary uppercase tracking-[0.15em] text-sm">
            <Sparkle size={18} weight="fill" /> Novità
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3 pt-1">
          {ENTRIES.map(({ icon: Icon, title, body }) => (
            <div key={title} className="flex gap-3 rounded-sm border border-border/60 bg-background/40 p-3" data-testid="whatsnew-item">
              <div className="shrink-0 w-9 h-9 rounded-sm bg-primary/15 text-primary flex items-center justify-center">
                <Icon size={18} weight="fill" />
              </div>
              <div className="space-y-0.5">
                <p className="text-sm font-semibold text-foreground">{title}</p>
                <p className="text-xs text-muted-foreground leading-relaxed">{body}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="flex justify-end pt-2">
          <Button onClick={dismiss} data-testid="whatsnew-dismiss" className="font-display uppercase tracking-wide text-xs">
            Ho capito
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
